import React from "react";
import { graphql } from "gatsby";
import Layout from "../components/layout";
import SEO from "../components/seo";
import FormularioScreen from "../components/nuevoEvento/FormularioScreen";

const NuevoEventoPage = ({ data }) => {
  let areasTematicas = data.allStrapiAgendaMasterAreaTematica.edges.map(
    (edge) => edge.node
  );
  let tiposEvento = data.allStrapiAgendaMasterTipoEvento.edges.map(
    (edge) => edge.node
  );

  let agendaMasterDirigidoA = data.allStrapiAgendaMasterDirigidoAs.edges.map(
    (edge) => edge.node
  );
  let agendaMasterEtiqueta = data.allStrapiAgendaMasterEtiqueta.edges.map(
    (edge) => edge.node
  );

  let agendaMasterLugarPucp = data.allStrapiAgendaMasterLugarPucp
    ? data.allStrapiAgendaMasterLugarPucp.edges.map((edge) => edge.node)
    : [];

  let agendaMasterUnidad = data.allStrapiAgendaMasterUnidad.edges.map(
    (edge) => edge.node
  );

  // console.log(`areasTematicas : ${JSON.stringify(areasTematicas)}`);

  areasTematicas = areasTematicas.sort(function (a, b) {
    return a.Nombre < b.Nombre ? -1 : a.Nombre > b.Nombre ? 1 : 0;
  });

  tiposEvento = tiposEvento.sort(function (a, b) {
    return a.Nombre < b.Nombre ? -1 : a.Nombre > b.Nombre ? 1 : 0;
  });

  agendaMasterLugarPucp = agendaMasterLugarPucp.sort(function (a, b) {
    return a.Nombre < b.Nombre ? -1 : a.Nombre > b.Nombre ? 1 : 0;
  });

  const resultData = {
    areasTematicas: areasTematicas,
    tipoEvento: tiposEvento,
    agendaMasterDirigidoA: agendaMasterDirigidoA,
    agendaMasterEtiqueta: agendaMasterEtiqueta,
    agendaMasterLugarPucp: agendaMasterLugarPucp,
    agendaMasterUnidad: agendaMasterUnidad,
    variablesEntorno: {
      AGENDA_APP_SITE: data.site.siteMetadata.AGENDA_APP_SITE,
    },
  };

  return (
    <Layout>
      <SEO title="Nuevo Evento" pathname="/nuevo-evento" />
      <FormularioScreen {...resultData} />
    </Layout>
  );
};
export default NuevoEventoPage;

export const pageQuery = graphql`
  query NuevoEventoQuery {
    allStrapiAgendaMasterAreaTematica {
      edges {
        node {
          Nombre
          id
          strapiId
        }
      }
    }
    allStrapiAgendaMasterTipoEvento {
      edges {
        node {
          Nombre
          TipoEvento
          id
          strapiId
        }
      }
    }
    allStrapiAgendaMasterEtiqueta {
      edges {
        node {
          Nombre
          id
          strapiId
        }
      }
    }
    allStrapiAgendaMasterDirigidoAs {
      edges {
        node {
          Nombre
          id
          strapiId
        }
      }
    }
    allStrapiAgendaMasterLugarPucp {
      edges {
        node {
          Nombre
          id
          strapiId
        }
      }
    }
    allStrapiAgendaMasterUnidad {
      edges {
        node {
          nombre
          id
          strapiId
        }
      }
    }
    site {
      siteMetadata {
        title
        AGENDA_APP_SITE
      }
    }
  }
`;
